// extracted by mini-css-extract-plugin
export var completionBody = "_kc-2";
export var completionCard = "_kc-0";
export var completionFooter = "_kc-3";
export var completionTitle = "_kc-1";